function generateFactoryId(length = 10) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let id = '';
    for (let i = 0; i < length; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
}

export function EvaluationFactoryData(data) {
    const output = [];

    // Dynamically use the key name instead of generating an ID
    for (const key in data) {
        if (key === "version") {
            continue; // Skip the 'version' property
        }

        if (key === "factors") {
            // Loop through each factor and add with a generated factory_id
            data.factors.forEach(factor => {
                output.push({
                    factor_id: factor.factor_id,
                    factor: factor.factor,
                    description: factor.description,
                    weight: factor.weight,
                    grading: factor.grading,
                    text_evaluations: factor.text_evaluations
                });
            });
        } else {
            // For other top-level keys (like general_evaluation), use key as factor_id
            output.push({
                factor_id: key,
                [key]: data[key] // dynamic key name
            });
        }
    }

    return output;
}

export function EvaluationFactoryAnswerData(factors) {
    const result = {
        client: null,
        general_evaluation: "",
        factors: []
    };

    for (const item of factors) {
        const key = item.factor_id;

        if (item.general_evaluation) {
            result.general_evaluation = "";
        } else {
            const textFields = (item.text_evaluations || []).map(te => [
                te.label.toLowerCase().replace(/\s+/g, '_'),
                null
            ]);

            result.factors.push({
                key,
                data: {
                    grade: null,
                    ...Object.fromEntries(textFields)
                }
            });
        }
    }

    return result;
}